import { render, staticRenderFns } from "./selected-criterion-checkbox.vue?vue&type=template&id=c4aecd92&scoped=true&"
import script from "./selected-criterion-checkbox.vue?vue&type=script&lang=js&"
export * from "./selected-criterion-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./selected-criterion-checkbox.vue?vue&type=style&index=0&id=c4aecd92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4aecd92",
  null
  
)

export default component.exports